var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidebar-menu',{staticStyle:{"max-width":"700px"},attrs:{"id":"sidebarViewer","menu":_vm.menu,"theme":_vm.theme}},[_c('inventry-generator')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04f1a5ba","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/sideBarInventryGenerator/SideBarInventryGenerator.vue
// module id = 1117
// module chunks = 0